import axios from 'axios';
import { CURRENT_API_URL } from "../../Utils/Constants";
import notify from '../../Notifications/ToastifyActions';


function FetchPendingReportsV3Service(token, data) {
    
    // id in productDetails is either a field called asin or a field called integerId
    return axios.post(`${CURRENT_API_URL}/sellerPartner/FetchPendingReportsV3FromUI`, data, {
        
        headers: {
            'Authorization': token,
        }
    }).then( notify.NotifySuccess("Fetching Pending Reports."))      
        .then(res => {
            return res.data;
        }).catch(() => {
            notify.NotifyError("An error occurred while Fetching Pending Report.");
            return false;
        });
}

export {
    FetchPendingReportsV3Service,
}